/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import { Container, Expired, PaymentForm, FormGroup, LoadingDiv, ClientData, DataContainer, Paid } from './style';
import { AutocompleteField, MaskedTextField, TextField } from '../../components/FormFields';
import { instituicaoFinanceira } from '../../mock/leadInfo.com';
import { LogoHorizontal, Bandeiras } from '../../components/Logo';
import { RemoveMask } from '../../utils/phoneMask';
import api from '../../service/api';
import { Loading } from '../../components/Loading';
import { DataParaEstiloPTBR, floatParaEstiloPTBR, formatarParaEstiloPTBR } from '../../hooks/Utils';

const OfflinePayment = () => {
  const { hash } = useParams();

  const hashParts = hash.split(';');
  const tenantId = hashParts[2];
  localStorage.setItem('tenantId', tenantId);

  const [values, setValues] = useState({});
  const [lead, setLead] = useState({});
  const [expired, setExpired] = useState({});
  const [loading, setLoading] = useState(true);
  const [paid, setPaid] = useState(false);

  const Pagar = async () => {
    const dataAtual = new Date();
    const [dateini, time] = new Date(dataAtual.setDate(dataAtual.getDate() + 3)).toISOString().split('T');
    
    if (!values.creditCardNumber && !values.securitycode && !values.expirationYear && !values.expirationMonth) {
      toast.warning('É necessário que todos os campos sejam preenchidos corretamente!');
      return;
    }

    if (values.expirationYear.length < 4) {
      toast.warning('O Ano de validade deve ter 4 dígitos!');
      return;      
    }

    if (values.expirationMonth.length < 2) {
      toast.warning('O Mês de validade deve ter 2 dígitos!');
      return;      
    }

    try {
      setLoading(true);
      const paymentData = {
        cartao: {
          numero: values.creditCardNumber,
          cvv: values.securitycode,
          validade: `${values.expirationYear}-${values.expirationMonth}`,
          paymentType: 1,
        },
      };

      const resp = await api.post(`externalInvoice/${hash}`, paymentData);
      if (resp.status == 200 || resp.status == 201) {
        toast.success(resp.data.message);
        setPaid(true);
      } else if (resp.status == 400) {
        toast.error(resp.data.message);
      } else {
        toast.error('Não foi possivel realizar o pagamento.');
      }
    } catch (error) {
      if (error.response.status == 400) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Não foi possivel realizar o pagamento.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBlur = (e) => {
    if (e.target?.minLength > 0 && e.target.value.length < e.target.minLength) {
      toast.warning(e.target.validationMessage);
      e.target.focus();
    }
  }

  const handleChange = (e, newValue, variable) => {
    if (!newValue) {
      setValues({
        ...values,
        [e.target.name]: e.target.value,
      });
    } else {
      setValues({
        ...values,
        [variable]: newValue,
      });
    }
  };

  useEffect(async () => {
    try {
      const resp = await api.get(`externalInvoice/${hash}`);

      if (resp.status === 200) {
        setExpired(false);
        setLead(resp.data);
      } else if (resp.status === 400 && resp.data?.message == 'A assinatura se encontra paga.') {
        setPaid(true);
      } else {
        setExpired(true);
      }
    } catch (error) 
    {
      console.log(`paymet error: ${error}`);
      if (error.response && error.response.status == 400 && error.response.data?.message == 'A assinatura se encontra paga.') {
        setPaid(true);
      } else {
        setExpired(true);
      }
    }
    setLoading(false);
  }, []);

  return (
    <>
      {loading && (
        <LoadingDiv>
          <Loading />
        </LoadingDiv>
      )}

      <Container>
        {paid ? (
          <Paid>
            <h1>Sucesso!</h1>
            <h5>A sua assinatura foi paga com sucesso.</h5>
            <h6>Tudo certo por aqui, você já pode realizar o fechamento dessa página.</h6>
          </Paid>
        ) : (
          <div>
            <LogoHorizontal />
            {!expired ? (
              <DataContainer>
                <ClientData>
                  <span>
                    <h2>Informações de cliente:</h2>
                  </span>
                  <div>
                    <div>
                      <span>
                        <b>Nome do cliente: </b>
                        {lead?.data?.nomeCliente}
                      </span>
                    </div>
                    <div>
                      <span>
                        <b>CPF: </b>
                        {lead?.data?.cpf}
                      </span>
                      <span>
                        <b>RG: </b>MG {lead?.data?.rg}
                      </span>
                    </div>
                    <div>
                      <span>
                        <b>Cidade: </b>
                        {lead?.data?.cidade}
                      </span>
                      <span>
                        <b>Estado: </b>
                        {lead?.data?.estado.name}
                      </span>
                    </div>
                    <div>
                      <span>
                        <b>Plano Contratado: </b>
                        {lead?.data?.plano}
                      </span>
                      <span>
                        <b>Valor da Parcela: </b>R$ {formatarParaEstiloPTBR(lead?.data?.valorParcela)}
                      </span>
                    </div>
                    <div>
                      <span>
                        <b>Inicio Vigencia: </b>
                        {DataParaEstiloPTBR(lead?.data?.inicioVigencia)}
                      </span>
                      <span>
                        <b>Final Vigencia: </b>
                        {DataParaEstiloPTBR(lead?.data?.fimVigencia)}
                      </span>
                    </div>
                  </div>
                </ClientData>
                <PaymentForm>
                  <span>
                    <h2>Informações de cobrança:</h2>
                  </span>
                  <div>
                    <FormGroup>
                      <MaskedTextField
                        required
                        mask="9999 9999 9999 9999"
                        value={values?.creditCardNumber || ''}
                        minDate={0}
                        onChange={handleChange}
                        varibleName="creditCardNumber"
                        label="Numero do Cartão"
                        maxChars={16}
                      />
                      <TextField
                        medium
                        valueText="Cartão de Crédito"
                        value="Cartão de Crédito"
                        varibleName="paymentType"
                        onChange={() => {}}
                        label="Forma de Pagamento"
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <TextField
                        required
                        value={values?.expirationMonth || ''}
                        minDate={0}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        varibleName="expirationMonth"
                        label="Mês Validade"
                        maxChars={2}
                        minChars={2}
                      />
                      <TextField
                        required
                        value={values?.expirationYear || ''}
                        minDate={0}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        varibleName="expirationYear"
                        label="Ano Validade"
                        maxChars={4}
                        minChars={4}
                      />
                      <TextField
                        required
                        value={values?.securitycode || ''}
                        minDate={0}
                        onChange={handleChange}
                        varibleName="securitycode"
                        label="Código de segurança"
                        maxChars={3}
                      />
                    </FormGroup>
                  </div>
                  <Button onClick={() => Pagar()} component="button" variant="contained" color="#f26522">
                    Realizar pagamento
                  </Button>
                </PaymentForm>
              </DataContainer>
            ) : (
              <Expired>
                <h4>FAVOR ENTRAR EM CONTATO COM O CORRETOR PARA GERAR UM NOVO LINK DE PAGAMENTO.</h4>
              </Expired>
            )}
          </div>
        )}

        <div style={{ backgroundColor: '#046875' }}>
          <Bandeiras />
        </div>
      </Container>
    </>
  );
};

export default OfflinePayment;
